import ApplicationAdapter from "./application";

export default class VpnUserAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.apiBaseUri}/vpn/createuser`;
  }

  urlForUpdateRecord() {
    return `${this.apiBaseUri}/vpn/edituser`;
  }

  urlForDeleteRecord(id, _, snapshot) {
    return `${this.apiBaseUri}/vpn/deleteuser?username=${id}&projectkey=${snapshot.belongsTo("project").id}`;
  }
}
